import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "styles", "brandProps", "links"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-shadow*/
import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../subkit-ui/basic/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var Navbar = function Navbar(_ref) {
  var classes = _ref.classes,
      styles = _ref.styles,
      brandProps = _ref.brandProps,
      links = _ref.links,
      props = _objectWithoutProperties(_ref, _excluded);

  var renderLink = function renderLink(link, index) {
    var name = link.name,
        type = link.type,
        classes = link.classes,
        onClick = link.onClick;
    return /*#__PURE__*/_jsx("span", {
      className: classNames('clickable', classes),
      onClick: onClick,
      children: type === 'icon' ? /*#__PURE__*/_jsx(Icon, {
        name: name,
        type: "regular"
      }) : name
    }, index);
  };

  return /*#__PURE__*/_jsxs("nav", _objectSpread(_objectSpread({
    className: "flex justify-between items-center nav-bar ".concat(classes),
    style: _objectSpread({}, styles)
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("img", {
      src: brandProps && brandProps.logo ? brandProps.logo.src : 'https://subkit-images.s3.amazonaws.com/images/logo.svg',
      alt: brandProps && brandProps.logo ? brandProps.logo.alt : 'Subkit Logo',
      className: "h-auto clickable my1 nav-brand ".concat(brandProps && brandProps.classes),
      style: _objectSpread({}, brandProps && brandProps.styles),
      onClick: brandProps.onClick
    }), /*#__PURE__*/_jsx("span", {
      children: links && links.map(renderLink)
    })]
  }));
};